import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Search from "../pages/search/page";
import Detail from "../pages/detail/page";
import About from "../pages/about/page";
import Read from "../pages/read/page";

const routes: RouteObject[] = [
  {
    path: "/read/:comicId/:chapterId",
    element: <Read />,
  },
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category", element: <Category /> },
      { path: "/search", element: <Search /> },
      { path: "/detail/:id", element: <Detail /> },
      { path: "/about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;